import React from 'react';
import { Field, useFormState } from 'react-final-form';
import { useIntl } from 'react-intl';

import { RFFFieldErrorWrapper } from 'common/components';
import LocalizedNumber from 'common/components/LocalizedNumber';
import { VatCategories, VatFieldValue, useVatCategories } from 'modules/menu/components/VatCategories';
import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';

import { BaseField } from './types';
import { FormRowRenderer } from '../FormRowRenderer';
import { DisplayText } from '../OfferDetailsFormFields.styles';
import { FormValues } from '../types';

export const Vat = ({ sidePanelMode, offer }: BaseField) => {
  const menuPermissions = useOfferingMenuPermissionsContext();
  const intl = useIntl();
  const { values } = useFormState<FormValues>();
  const { data: vatCategories } = useVatCategories();

  const previewComponent = (
    <DisplayText>
      <LocalizedNumber
        value={Number(values.vat.percentage) / 100}
        options={{
          style: 'percent',
          maximumFractionDigits: 2,
        }}
      />
    </DisplayText>
  );

  const editComponent = (
    <Field<VatFieldValue> name="vat">
      {field => (
        <RFFFieldErrorWrapper field={field} showErrorImmediately>
          {input => (
            <VatCategories {...input} vatCategories={vatCategories?.list} disabled={false} lang={intl.locale} />
          )}
        </RFFFieldErrorWrapper>
      )}
    </Field>
  );

  return (
    <FormRowRenderer
      hasContentEditPermission={menuPermissions.contentEdit && menuPermissions.itemVatChange}
      label={intl.formatMessage({ id: 'menu-item.vat-label-edit' })}
      previewComponent={previewComponent}
      editComponent={editComponent}
      shouldDisplayCreateTag={!values.vat}
      sidePanelMode={sidePanelMode}
      offer={offer}
      required
    />
  );
};
